import { FiniteListWithAsyncLoaderAbstract, ListProps } from "../shared/components/Components";
import { useMercuryContext } from "../context";

export const fetchLanguageCodes = async (context: any) => {
  const { data } = await context.gpClient.get(
    "/google-gp-v1/plp/uniqueLanguageCodes"
  );
  return data.map((item: any) => ({
    title: item,
    value: item,
  }));
};
class LanguageCodeFilter extends FiniteListWithAsyncLoaderAbstract {
  fetch() {
    return fetchLanguageCodes(this.props.context);
  }
}

export default (props: ListProps) => {
  const context = useMercuryContext();
  return <LanguageCodeFilter context={context} {...props} />;
};
